// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 138) return "static/css/138.86069f96d23774911020.lib.css";
	if (chunkId === 353) return "static/css/353.531429262a3b9d07f6ed.css";
	// return url for filenames based on template
	return undefined;
};